<template>
  <div>

    <!-- Application form modal -->
    <b-modal v-model="modalShow" hide-footer>
      <form ref="form" @submit.prevent="submitJobApplication">
        <!-- Name field -->
        <b-form-group
          label="Name"
          label-for="name"
          :state="!errors.name"
          invalid-feedback="Please enter a valid name"
        >
          <b-form-input
            id="name"
            name="Name"
            placeholder="Enter your name"
            required
          ></b-form-input>
        </b-form-group>

        <!-- Resume upload field -->
        <b-form-group
          label="Resume Upload"
          label-for="resume"
          :state="!errors.resume"
          invalid-feedback="Please upload a valid resume"
        >
          <b-form-file
            id="resume"
            name="Resume"
            type="file"
            required
            accept="application/pdf, image/svg, image/jpeg"
          ></b-form-file>
        </b-form-group>

        <!-- Contact number field -->
        <b-form-group
          label="Contact Number"
          label-for="contactNumber"
          :state="!errors.contactNumber"
          invalid-feedback="Please enter a valid contact number"
        >
          <b-form-input
            id="contactNumber"
            name="Contact Number"
            placeholder="Enter your contact number"
            required
          ></b-form-input>
        </b-form-group>

        <!-- Email address field -->
        <b-form-group
          label="Email Address"
          label-for="email"
          :state="!errors.email"
          invalid-feedback="Please enter a valid email address"
        >
          <b-form-input
            id="email"
            type="email"
            name="Email"
            placeholder="Enter your email address"
            required
          ></b-form-input>
        </b-form-group>

        <!-- Current CTC field -->
        <b-form-group
          label="Current CTC"
          label-for="cctc"
          :state="!errors.ctc"
          invalid-feedback="Please enter a valid current CTC"
        >
          <b-form-input
            id="cctc"
            name="Current CTC"
            placeholder="Enter your current CTC"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Expected CTC"
          label-for="ectc"
          :state="!errors.ctc"
          invalid-feedback="Please enter a valid current CTC"
        >
          <b-form-input
            id="ectc"
            name="Expected CTC"
            placeholder="Enter your expected CTC"
            required
          ></b-form-input>
        </b-form-group>
        <div v-if="modalJob">
          <input type="hidden" name="Job Title" :value="modalJob.cj_title" />
          <input
            type="hidden"
            name="Job Category"
            :value="modalJob.cj_category"
          />
          <input type="hidden" name="Job Level" :value="modalJob.cj_level" />
          <input
            type="hidden"
            name="Job Location"
            :value="modalJob.cj_location"
          />
          <input type="hidden" name="Job Type" :value="modalJob.cj_type" />
        </div>

        <!-- Submit button -->
        <b-button type="submit" variant="primary">Submit</b-button>
      </form>
    </b-modal>

    <div class="career-hero" style="margin-top: 130px">
      <h1
        class="text-center font-weight-bold"
        style="height: 300px; padding-top: 5rem; font-size: 70px"
      >
        Explore Exciting Opportunities <br />with Aliff Careers
      </h1>
      <div class="">
        <img
          src="@/assets/imgs/study-abroad-hero-img.png"
          alt=""
          class="w-100"
        />
      </div>
    </div>

    <div class="container">
      <!-- <div class="row align-items-center row-cols-1 row-cols-md-2" >
        <div class="col">
          <h2 class="font-weight-bold">
            Come Aboard The Aliff Edu Rocket-ship
          </h2>
          <p>
            Ready to give your career the right boost? <br />
            Be a part of India's fastest growing ed-tech company!
          </p>
        </div>
        <div class="col">
          <img src="@/assets/imgs/career-image.png" alt="" class="w-100" />
        </div>
      </div> -->
      <section id="who-are-we" class="py-5">
        <div class="container">
          <div class="row align-items-center py-3 row-cols-1 row-cols-md-2">
            <div class="col">
              <img
                src="@/assets/imgs/career-about.png"
                alt="Aliff Team"
                class="img-fluid"
              />
            </div>
            <div class="col">
              <h2 class="font-weight-bold">Who Are We ?</h2>
              <p>
                Aliff, established in 2008, has offices across India, UAE,
                Kuwait & the USA. With a 100% admission success rate, Aliff has
                a counselling experience of 23K+ students. Our students have
                received Scholarships of worth Rs. 28+ Crore (US$ 3.2+ Million)
                to study at prestigious universities.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="py-5">
        <h2 class="font-weight-bold text-center">Awards And Recognition</h2>
        <div class="row py-5 row-cols-1 row-cols-md-2 row-cols-lg-3">
          <div class="col">
            <img
              src="../../../assets/imgs/awards/award-8.jpg"
              alt=""
              class="img-fluid"
            />
          </div>
          <div class="col">
            <img
              src="../../../assets/imgs/awards/award-4.jpg"
              alt=""
              class="img-fluid"
            />
          </div>
          <div class="col">
            <img
              src="../../../assets/imgs/awards/award-10.jpg"
              alt=""
              class="w-100"
              height="350px"
              style="object-fit: cover"
            />
          </div>
        </div>
      </section>
      <section class="py-5">
        <h2 class="font-weight-bold text-center">Whom We Value ?</h2>
        <div class="row py-3 row-cols-1 row-cols-md-2 align-items-center">
          <div class="col">
            <h3>At Aliff, our appreciation extends to:</h3>
            <ul>
              <li>
                <strong>Students:</strong> Your dreams inspire us. We're here to
                guide and support you.
              </li>
              <li>
                <strong>Parents and Families:</strong> We value the trust you
                place in us for your loved ones.
              </li>
              <li>
                <strong>Educational Institutions:</strong> Our partnerships
                provide top-tier education opportunities.
              </li>
              <li>
                <strong>Aliff Team:</strong> Their dedication makes study abroad
                dreams a reality.
              </li>
              <li>
                <strong>Collaborators and Partners:</strong> Valuable support to
                ensure student success.
              </li>
              <li>
                <strong>The Aliff Community:</strong> A diverse, inclusive, and
                supportive network.
              </li>
              <li>
                <strong>Future Generations:</strong> Our commitment to creating
                opportunities for tomorrow.
              </li>
            </ul>
          </div>
          <div class="col">
            <img
              src="@/assets/imgs/career-value.png"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
      </section>

      <div class="career-story py-5">
        <div class="story-text text-center">
          <h2 class="font-weight-bold">Why Work With Us ?</h2>
          <p
            class="pt-2 text-capitalize font-weight-bold font-italic"
            style="text-decoration: underline"
          >
            We Bring study abroad within the common man's reach
          </p>
          <p class="py-2">
            Established in 2008, our education consultancy boasts multiple
            offices across Asia and over 23,000 counseling experiences. With a
            100% admission success rate, our Unique 3C Model (Right Course,
            College, Country) sets us apart. Recognized among the Top 10 Most
            Recommended Consultants, we offer a proven and personalized approach
            to academic success.
          </p>
        </div>
        <div class="story-cards row justify-content-center" style="gap: 50px">
          <div
            class="rounded-1 p-2 card-col col-12 col-md-6 col-lg-4 story-card-col"
            v-for="(card, index) in cards"
            :key="index"
            style="border: 3px solid #83aef465"
          >
            <div class="card-body">
              <i
                v-if="card.icon"
                :class="'bi bi-' + card.icon"
                style="font-size: 40px; margin-bottom: 10px; color: #5367ff"
              ></i>
              <h3 class="card-title my-2">{{ card.title }}</h3>
              <p class="card-text">{{ card.para }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="job-story py-5">
        <div class="job-story-text">
          <h2 class="font-weight-bold mb-4">Job Openings</h2>
          <div>
            <!-- Filters -->
            <div class="d-flex justify-content-around align-items-center px-5">
              <b-row style="width: 100%">
                <b-col>
                  <b-form-group>
                    <v-select
                      placeholder="Category"
                      :options="categories"
                      v-model="filters.category"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <v-select
                      placeholder="Location"
                      :options="locations"
                      v-model="filters.location"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <v-select
                      placeholder="Level"
                      :options="levels"
                      v-model="filters.level"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div
          class="job-cards d-flex flex-wrap mt-5"
          v-for="(category, index) in filteredJobs"
          :key="'cat' + index"
        >
          <div class="d-flex align-items-center mb-3">
            <img src="../../../assets/imgs/engineering.png" alt="" width="50" />
            <h2 class="mb-0 ms-2" style="padding-left: 15px">
              {{ category.cj_category }}
            </h2>
          </div>
          <div
            class="new-card rounded p-4 w-100 border-bottom-1 mb-3"
            v-for="(job, jobIndex) in category.jobs"
            :key="'job' + jobIndex"
          >
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <div class="title">
                <h3 class="mb-0 font-weight-bold">{{ job.cj_title }}</h3>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <p class="text-muted mb-0">
                  <i class="fas fa-map-marker-alt"></i> {{ job.cj_location }}
                </p>
              </div>
              <div>
                <p class="mb-0">
                  <i class="fas fa-clock"></i> {{ job.cj_type }}
                </p>
              </div>
              <div class="text-center">
                <button
                  class="border-0 bg-transparent"
                  @click="toggleModal(job.cj_id)"
                >
                  <i
                    :class="
                      collapseIcons[job.cj_id]
                        ? 'bi bi-dash text-dark font-weight-bold fs-1'
                        : 'bi bi-plus text-dark font-weight-bold fs-1'
                    "
                    style="font-size: 30px"
                  ></i>
                </button>
              </div>
            </div>
            <b-collapse
              :id="'collapse' + job.cj_id"
              class="text-center w-100 py-3"
            >
              <div class="text-center">
                <h4>{{ job.cj_title }}</h4>
                <p v-html="job.cj_description"></p>
                <button
                  class="btn btn-primary btn-lg"
                  @click="openModalForm(job)"
                >
                  Apply Now
                </button>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
      <div class="life-story text-center py-5">
        <h2 class="font-weight-bold">Life @ Aliff Edu</h2>
        <p>'Work hard, party harder' comes true at Aliff Edu.</p>
        <b-row class="mb-2">
          <b-col>
            <img
              src="../../../assets/imgs/careers/photo3.png"
              alt=""
              class="img-fluid"
            />
          </b-col>
          <b-col>
            <img
              src="../../../assets/imgs/careers/photo5.png"
              alt=""
              class="img-fluid"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <img
              src="../../../assets/imgs/careers/photo1.png"
              alt=""
              class="img-fluid"
            />
          </b-col>

          <b-col>
            <img
              src="../../../assets/imgs/careers/photo2.png"
              alt=""
              class="img-fluid"
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import homeServices from "@/apiServices/homeServices";
import vSelect from "vue-select";
import axios from "axios";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      collapseIcons: {},

      cards: [
        {
          title: "Student First",
          para: "Saving the aspirant’s money & effort through expert guidance and advanced technology support.",
          icon: "mortarboard",
        },
        {
          title: "Transparency",
          para: "Honest clear communication with all stakeholders.",
          icon: "globe",
        },
        {
          title: "Research & innovation",
          para: "About futurist courses, modern universities & favorable foreign policies.",
          icon: "lightbulb",
        },
        {
          title: "Passion",
          para: "Showcase during any form of interaction.",
          icon: "heart",
        },
        {
          title: "Go the extra mile",
          para: "To make every student’s journey with Aliff enjoyable & memorable.",
          icon: "arrow-right-circle",
        },
      ],

      selected: null,
      jobs: [],
      categories: [],
      locations: [],
      levels: [],
      jdModal: false,
      modalJob: null,
      modalShow: false,

      filters: {
        category: "",
        level: "",
        location: "",
      },
      // form: {
      //   "Name": "",

      // }
    };
  },
  computed: {
    filteredJobs: function () {
      const cJobs = [];
      if (!this.jobs.length) {
        return [];
      }
      for (const jc of this.jobs) {
        if (this.filters.category && this.filters.category !== jc.cj_category) {
          continue;
        }
        const jobs = [];
        for (const j of jc.jobs) {
          if (this.filters.level && this.filters.level !== j.cj_level) {
            continue;
          }
          if (
            this.filters.location &&
            this.filters.location !== j.cj_location
          ) {
            continue;
          }
          jobs.push(j);
        }
        if (jobs.length) {
          cJobs.push({
            cj_category: jc.cj_category,
            jobs,
          });
        }
      }
      return cJobs;
    },
  },
  methods: {
    openModalForm(job) {
      this.modalJob = job;
      this.modalShow = true;
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          reject(error);
        };
      });
    },
    async submitJobApplication() {

      let formData = {};

      Array.from(this.$refs.form.elements).forEach((element) => {
        console.log({ element });
        if (element.type !== "submit" && element.type !== "file") {
          formData[element.name] = element.value;
        }
      });

      const resume = document.getElementById("resume");
      let base64Image = await this.getBase64(resume.files[0]);

      base64Image = base64Image.split(",")[1];

      const res = await homeServices.sendCareerFormMail({
        formData,
        content: [{ name: resume.files[0].name, content: base64Image }],
      });

      this.modalShow = false;
    },

    async getJobs() {
      const res = await homeServices.getCareersJobs();
      const jobData = res.data; // Assuming the job data is in response.data

      this.jobs = jobData.data.jobs;
      this.categories = jobData.data.categories;
      this.locations = jobData.data.locations;
      this.levels = jobData.data.levels;
    },

    // openModal(job) {
    //   this.modalJob = job;
    //   this.jdModal = true;
    // },
    toggleModal(cj_id) {
      console.log(cj_id);
      // console.log(cj_id)
      //   if (this.modalJob === job) {
      //     // If the same job is clicked again, collapse it
      //     this.modalJob = null;
      //   } else {
      //     // Otherwise, open the modal for the clicked job
      //     this.modalJob = job;
      //   }
      this.$root.$emit("bv::toggle::collapse", "collapse" + cj_id);
      this.$set(this.collapseIcons, cj_id, !this.collapseIcons[cj_id]);
    },
  },
  beforeMount() {
    this.getJobs();
  },
};
</script>
<style>
.features-story ul li {
  color: rgba(135, 135, 135, 0.755);
}
.new-card {
  padding: 20px;
}
.formbold-mb-5 {
  margin-bottom: 20px;
}
.formbold-pt-3 {
  padding-top: 12px;
}
.formbold-main-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.formbold-form-wrapper {
  margin: 0 auto;
  max-width: 550px;
  width: 100%;
  background: white;
}
.formbold-form-label {
  display: block;
  font-weight: 500;
  font-size: 16px;
  color: #07074d;
  margin-bottom: 12px;
}
.formbold-form-label-2 {
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 20px;
}

.formbold-form-input {
  width: 100%;
  padding: 12px 24px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  background: white;
  font-weight: 500;
  font-size: 16px;
  color: #6b7280;
  outline: none;
  resize: none;
}
.formbold-form-input:focus {
  border-color: #6a64f1;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
}

.formbold-btn {
  text-align: center;
  font-size: 16px;
  border-radius: 6px;
  padding: 14px 32px;
  border: none;
  font-weight: 600;
  background-color: #6a64f1;
  color: white;
  cursor: pointer;
}
.formbold-btn:hover {
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
}

.formbold--mx-3 {
  margin-left: -12px;
  margin-right: -12px;
}
.formbold-px-3 {
  padding-left: 12px;
  padding-right: 12px;
}
.flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
.w-full {
  width: 100%;
}
.new-card {
  background: aliceblue;
}
.card-col {
  flex: 0 0 30.333333% !important;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.story-card-col {
  transition: 0.3s;
  border-radius: 30px;
}
.story-card-col:hover {
  background-color: #83aef465;
}
.bi::before,
[class^="bi-"]::before,
[class*=" bi-"]::before {
  font-weight: 900 !important;
}

@media screen and (max-width: 769px) {
  .card-col {
    flex: 0 0 46% !important;
  }
}

@media screen and (max-width: 425px) {
  .card-col {
    flex: 0 0 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AliffCareers/AliffCareers.vue